import 'isomorphic-fetch';

function removeOptions(selectBox) {
  for (let i = selectBox.options.length - 1; i >= 0; i -= 1) {
    if (i !== 0) {
      selectBox.remove(i);
    }
  }
}

function getModelsByMake(event, allModels) {
  let models;
  const modelInput = document.getElementById('model');
  const makeId = event.target.value;
  Object.keys(allModels).map((objectKey) => {
    const value = allModels[objectKey];
    // @NOTE: strict comparison is not working, I think it's a problem with typecasting
    if (value.key === parseInt(makeId, 10)) {
      models = value.values;
    }
    return models;
  });

  removeOptions(modelInput);
  Object.keys(models).map((objectKey) => {
    const model = models[objectKey];
    const option = document.createElement('option');
    option.text = model.display;
    option.value = model.key;
    modelInput.appendChild(option);
    return null;
  });
}

(() => {
  const makeSelect = document.getElementById('make');
  const { vehicleType } = makeSelect.dataset;
  const { actives } = makeSelect.dataset;
  const url = `/getJsonModels/${vehicleType}/${actives}`;

  fetch(url)
    .then((res) => res.json())
    .then((out) => {
      makeSelect.addEventListener('change', (event) => { getModelsByMake(event, out); });
    })
    .catch((err) => { throw err; });
})();
